import { cn } from '@/lib/utils';
import { ensureSmsOptOut } from './sms-editor-constants';

export interface SmsPhoneMockupProps {
  messageBody: string;
  mediaUrls: string[];
  headerText?: string;
  compact?: boolean;
  /**
   * Preview the message as it is sent: with `{{opt_out}}` appended when the
   * body has no opt-out instructions. The editors pass this so the preview
   * matches what save adds; read-only views show the stored body as-is.
   */
  appendOptOut?: boolean;
}

export default function SmsPhoneMockup({
  messageBody,
  mediaUrls,
  headerText = 'Message Preview',
  compact = false,
  appendOptOut = false,
}: SmsPhoneMockupProps) {
  const width = compact ? 'w-[230px]' : 'w-[280px]';
  const screenHeight = compact ? 'h-[340px]' : 'h-[520px]';
  const shownBody = appendOptOut ? ensureSmsOptOut(messageBody) : messageBody;

  return (
    <div className={cn(width, 'bg-slate-100 rounded-[30px] border-[3px] border-slate-300 p-2.5 shadow-md')}>
      <div className={cn('bg-white rounded-[22px] overflow-hidden flex flex-col', screenHeight)}>
        <div className="px-4 py-2.5 text-xs text-slate-400 text-center border-b border-slate-50 flex-shrink-0">
          {headerText}
        </div>
        <div className="flex-1 overflow-y-auto p-4 min-h-0">
          {mediaUrls.map((url, i) => (
            <div key={i} className="max-w-[85%] mb-2 rounded-xl overflow-hidden">
              <img src={url} alt="Media" className="w-full block" />
            </div>
          ))}
          <div className="max-w-[85%] px-3.5 py-2.5 bg-slate-200 rounded-2xl rounded-bl text-sm leading-relaxed whitespace-pre-wrap break-words text-slate-700">
            {shownBody || 'Your message will appear here...'}
          </div>
        </div>
      </div>
    </div>
  );
}
